import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { Results } from '../../components/Results';
import { selectResults, selectIsSearcherOrSub } from '../../selectors';
import { isFavoritesForAuthorizationEnabled } from '../../selectors/experiments/isFavoritesForAuthorizationEnabled';
import { selectFilters } from '../../selectors/filters';
import { EEntityType } from '../../types/filters';
import { FolderHeaderContainer } from '../FolderHeader';
import { FoldersListContainer } from '../FoldersList';
import { TopBarContainer } from '../TopBar';

export function ResultsContainer() {
  const dispatch = useDispatch();
  const results = useSelector(selectResults);
  const { favoriteEntityType } = useSelector(selectFilters);
  const isSearcherOrSub = useSelector(selectIsSearcherOrSub);
  const isFoldersListVisible = favoriteEntityType !== EEntityType.Newbuilding;
  const favoritesForAuthorizationEnabled = useSelector(isFavoritesForAuthorizationEnabled);

  React.useEffect(() => {
    if (favoritesForAuthorizationEnabled) {
      dispatch(requestAuthentication());
    }
  }, [dispatch, favoritesForAuthorizationEnabled]);

  return (
    <Results
      results={results}
      isSearcherOrSub={isSearcherOrSub}
      foldersList={isFoldersListVisible && <FoldersListContainer />}
      foldersHeader={isFoldersListVisible && <FolderHeaderContainer />}
      topBar={<TopBarContainer />}
      isFavoritesForAuthorizationEnabled={favoritesForAuthorizationEnabled}
    />
  );
}
